import { render } from "./Milestones.vue?vue&type=template&id=ab4819a8&ts=true"
import script from "./Milestones.vue?vue&type=script&lang=ts"
export * from "./Milestones.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__